<template>
  <div class="udan-ems-dialog">
    <!-- 更新提示框 -->
    <el-dialog :title="null" :visible.sync="dialogVisible" class="dialog-desc" width="960px" :before-close="handleClose">
      <div slot="title" class="dialog-title">
        <svg-icon style="height: 25px; width: 25px" :icon-file-name="'layout-desc'" />
        <h3>功能更新说明</h3>
      </div>
      <div class="itembox1">
        <div class="update-Time">【2024-07-15 更新内容】</div>
        <div class="Page-newfunc">
          <h4>新增功能</h4>
          <div class="Page-newfunc-detail">
            <h4>数据接入</h4>
            <div class="pndcontent">新增第三方能源管理平台数据接入能力。</div>
          </div>
        </div>
      </div>
      <div class="itembox1">
        <div class="update-Time">【2024-07-13 更新内容】</div>
        <div class="Page-newfunc">
          <h4>新增功能</h4>
          <div class="Page-newfunc-detail">
            <h4>个人信息</h4>
            <div class="pndcontent">新增查看账号个人信息。</div>
            <h4 class="title-top">账号管理</h4>
            <div class="pndcontent">新增设置账号到期时间。</div>
          </div>
        </div>
      </div>
      <div class="itembox1">
        <div class="update-Time">【2024-06-28 更新内容】</div>
        <div class="Page-newfunc">
          <h4>新增功能</h4>
          <div class="Page-newfunc-detail">
            <h4>数据接入</h4>
            <div class="pndcontent">新增第三方光伏管理平台数据接入能力。</div>
          </div>
        </div>
      </div>

      <div class="itembox1">
        <div class="update-Time">【2024-06-21 更新内容】</div>
        <div class="Page-newfunc">
          <h4>新增功能</h4>
          <div class="Page-newfunc-detail">
            <h4>告警中心</h4>
            <div class="pndcontent">新增告警中心-告警监控功能，支持多站告警内容汇总展示。</div>
          </div>
        </div>
        <div class="Page-newfunc Page-funcoptimization">
          <h4>功能优化</h4>
          <div class="Page-newfunc-detail">
            <h4>站点告警</h4>
            <div class="pndcontent">支持电站内所有系统告警内容汇总展示。</div>
          </div>
        </div>
      </div>

      <div class="itembox1">
        <div class="update-Time">【2024-05-29 更新内容】</div>
        <div class="Page-newfunc">
          <h4>新增功能</h4>
          <div class="Page-newfunc-detail">
            <h4>设备监控</h4>
            <div class="pndcontent">电表新增相电压、相电流、电网频率字段。</div>
          </div>
        </div>
      </div>
      <div class="itembox1">
        <div class="update-Time">【2024-05-25 更新内容】</div>
        <div class="Page-newfunc">
          <h4>新增功能</h4>
          <div class="Page-newfunc-detail">
            <h4>系统管理</h4>
            <div class="pndcontent">系统管理新增设备录入，支持调试人员自行录入关联设备；</div>
            <div class="pndcontent">系统管理新增控制配置，支持调试人员配置“系统控制”与“设备控制”功能开关。</div>
            <h4 class="title-top">设备监控</h4>
            <div class="pndcontent">电网电表类型区分高压侧与低压侧。</div>
          </div>
        </div>
      </div>

      <div class="itembox1">
        <div class="update-Time">【2024-05-18 更新内容】</div>
        <div class="Page-newfunc">
          <h4>功能优化</h4>
          <div class="Page-newfunc-detail">
            <h4>站点系统</h4>
            <div class="pndcontent">系统切换功能优化，在系统数超过5个时，支持进行搜索。</div>
          </div>
        </div>
        <div class="Page-newfunc Page-funcoptimization">
          <h4>新增功能</h4>
          <div class="Page-newfunc-detail">
            <h4>电站管理</h4>
            <div class="pndcontent">电站列表新增系统数量，支持点击进入电站系统管理子页面；</div>
            <div class="pndcontent">支持在电站管理-系统管理中主动进行系统绑定/解绑操作；</div>
            <div class="pndcontent">支持在电站管理-系统管理中对站点系统主从展示进行配置。</div>

            <h4 class="title-top">设备监控</h4>
            <div class="pndcontent">新增支持DCDC设备；</div>
            <div class="pndcontent">电表新增功率因数、无功功率、视在功率字段；</div>
            <div class="pndcontent">外设新增 DO 状态。</div>
          </div>
        </div>
      </div>

      <div class="itembox1">
        <div class="update-Time">【2024-05-08 更新内容】</div>
        <div class="Page-newfunc">
          <h4>新增功能</h4>
          <div class="Page-newfunc-detail">
            <h4>设备监控-电表</h4>
            <div class="pndcontent">电表新增电流互感器变比、电压互感器变比、原始值字段。</div>
          </div>
        </div>
        <div class="Page-newfunc Page-funcoptimization">
          <h4>功能优化</h4>
          <div class="Page-newfunc-detail">
            <h4>平台搜索</h4>
            <div class="pndcontent">平台搜索功能优化，支持模糊搜索。</div>
          </div>
        </div>
      </div>
      <div class="itembox1">
        <div class="update-Time">【2024-04-25 更新内容】</div>
        <div class="Page-newfunc">
          <h4>功能优化</h4>
          <div class="Page-newfunc-detail">
            <h4>电量报表 - 时段报表</h4>
            <div class="pndcontent">时段报表中的原始数据部分支持自定义日期范围导出和趋势图时间轴调整。</div>
          </div>
        </div>
      </div>
      <div class="itembox1">
        <div class="update-Time">【2024-04-10 更新内容】</div>
        <div class="Page-newfunc">
          <h4>新增功能</h4>
          <div class="Page-newfunc-detail">
            <h4>系统管理</h4>
            <div class="pndcontent">系统管理列表新增ICCID字段。</div>
          </div>
        </div>
      </div>
      <div class="itembox1">
        <div class="update-Time">【2024-04-01 更新内容】</div>
        <div class="Page-newfunc">
          <h4>新增功能</h4>
          <div class="Page-newfunc-detail">
            <h4>动态电价</h4>
            <div class="pndcontent">支持海外电站自动获取对应区域电价数据并导入平台中，支持自动更新到最新电价。</div>
            <h4 class="title-top">智慧控制</h4>
            <div class="pndcontent">支持根据平台算法生成能量控制策略并执行。</div>
            <h4 class="title-top">手动能量控制</h4>
            <div class="pndcontent">新增SOC设置，支持设置充放电目标SOC。</div>
          </div>
        </div>
        <div class="Page-newfunc Page-funcoptimization">
          <h4>功能优化</h4>
          <div class="Page-newfunc-detail">
            <h4>设备监控 & 系统管理</h4>
            <div class="pndcontent">BMS设备 - 电池堆、电池簇、电池单体视图的 UI 样式优化。</div>
            <h4 class="title-top">数据分析</h4>
            <div class="pndcontent">新增电池簇&单体电池视图-数据分析功能。</div>
          </div>
        </div>
      </div>
      <div class="itembox1">
        <div class="update-Time">【2024-03-15 更新内容】</div>
        <div class="Page-newfunc">
          <h4>功能优化</h4>
          <div class="Page-newfunc-detail">
            <h4>设备监控</h4>
            <div class="pndcontent">设备监控页面 UI 样式优化。</div>
          </div>
        </div>
      </div>
      <div class="itembox1">
        <div class="update-Time">【2024-03-01 更新内容】</div>
        <div class="Page-newfunc">
          <h4>新增功能</h4>
          <div class="Page-newfunc-detail">
            <h4>本地/远程控制</h4>
            <div class="pndcontent">能量管理支持本地和远程控制模式。</div>
            <h4 class="title-top">数据大屏</h4>
            <div class="pndcontent">大屏 UI样式更新，支持全球地图。</div>
          </div>
        </div>
      </div>
      <div class="itembox1">
        <div class="update-Time">【2024-02-07 更新内容】</div>
        <div class="Page-newfunc">
          <h4>新增功能</h4>
          <div class="Page-newfunc-detail">
            <h4>系统批量操作</h4>
            <div class="pndcontent">系统管理-系统分配，支持用户进行批量分配操作。</div>
            <h4 class="title-top">多端同步</h4>
            <div class="pndcontent">能量管理的控制参数，从本地（显示屏）下发后，远程（平台/App）将与本地保持一致，反之同理。</div>
          </div>
        </div>
      </div>
      <div class="itembox1">
        <div class="update-Time">【2024-01-27 更新内容】</div>
        <div class="Page-newfunc">
          <h4>新增功能</h4>
          <div class="Page-newfunc-detail">
            <h4>设备监控</h4>
            <div class="pndcontent">设备监控新增数据分析功能，支持展示设备字段的历史数据图。</div>
          </div>
        </div>
        <div class="Page-newfunc Page-funcoptimization">
          <h4>功能优化</h4>
          <div class="Page-newfunc-detail">
            <h4>中英文版本</h4>
            <div class="pndcontent">设备名称支持跟随语言环境切换</div>
          </div>
        </div>
      </div>
      <div class="itembox1">
        <div class="update-Time">【2024-01-26 更新内容】</div>
        <div class="Page-newfunc">
          <h4>界面优化</h4>
          <div class="Page-newfunc-detail">
            <h4>站点系统</h4>
            <div class="pndcontent">能量流转图的 icon 样式优化 ；系统离线后，能量流转效果将会停止。</div>
          </div>
        </div>
      </div>
      <div class="itembox1">
        <div class="update-Time">【2024-01-19 更新内容】</div>
        <div class="Page-newfunc">
          <h4>功能优化</h4>
          <div class="Page-newfunc-detail">
            <h4>站点卡片</h4>
            <div class="pndcontent">修复已知问题，优化区域筛选和搜索能力。</div>
            <h4 class="title-top">电站管理</h4>
            <div class="pndcontent">新增电站图片上传示例说明。</div>
          </div>
        </div>
      </div>
      <div class="itembox1">
        <div class="update-Time">【2024-01-08 更新内容】</div>
        <div class="Page-newfunc">
          <h4>新增功能</h4>
          <div class="Page-newfunc-detail">
            <h4>时段报表</h4>
            <div class="pndcontent">
              电量报表-单站报表：报表类型新增时段报表，支持按天查看时段数据与原始数据，时段数据：多种方式展示每小时的电量数据（折线图、柱状图和表格）；原始数据：展示站点下每个系统的当日电量、累计电量，支持导出。
            </div>
          </div>
        </div>
      </div>
      <div class="itembox1">
        <div class="update-Time">【2024-01-06 更新内容】</div>
        <div class="Page-newfunc">
          <h4>功能优化</h4>
          <div class="Page-newfunc-detail">
            <h4>能量控制</h4>
            <div class="pndcontent">时间设置冲突限制提醒改为应用时提示，支持使用鼠标滑轮选择时间。</div>
          </div>
        </div>
      </div>
      <div class="itembox3">
        <div class="update-Time">【2024-01-05 更新内容】</div>
        <div class="Page-newfunc">
          <h4>功能优化</h4>
          <div class="Page-newfunc-detail">
            <h4>实时运行</h4>
            <div class="pndcontent">新增数据类型：电池堆-单体最低电压。</div>
            <h4 class="title-top">电价管理</h4>
            <div class="pndcontent">电价模板-时段与电价：时间设置冲突限制提醒改为应用时提示。</div>
            <h4 class="title-top">故障告警</h4>
            <div class="pndcontent">新增客户告警字段，展示原始告警内容。</div>
          </div>
        </div>
      </div>
      <div class="itembox1">
        <div class="update-Time">【2023-12-29 更新内容】</div>
        <div class="Page-newfunc">
          <h4>新增功能</h4>
          <div class="Page-newfunc-detail">
            <h4>站点卡片</h4>
            <div class="pndcontent">支持电站卡片化展示和区域筛选。</div>
          </div>
        </div>
      </div>
      <div class="itembox1">
        <div class="update-Time">【2023-12-27 更新内容】</div>
        <div class="Page-newfunc">
          <h4>功能优化</h4>
          <div class="Page-newfunc-detail">
            <h4>站点搜索</h4>
            <div class="pndcontent">平台站点切换选择时，支持搜索能力。</div>
          </div>
        </div>
      </div>
      <div class="itembox2">
        <div class="update-Time">【2023-12-20 更新内容】</div>
        <div class="Page-adjustment">
          <h4>页面调整</h4>
          <div class="Page-adjust-content">
            <h4>平台名称</h4>
            <div class="padcontent">平台中文名称调整为“智慧储能云平台”，英文为“Intelligent Energy Storage Cloud Platform”。</div>
          </div>
        </div>
        <div class="Page-newfunction">
          <h4>新增功能</h4>
          <div class="Page-newfunc-content">
            <h4>工单管理</h4>
            <div class="pncontent">新增工单管理功能，帮助用户在平台上管理、维护和追踪站点问题与请求。</div>
            <h4 class="title-top">设备监控-数据导出</h4>
            <div class="pncontent">设备监控新增“数据导出”按钮，支持按日范围导出PCS、电表和BMS数据报表。</div>
          </div>
        </div>
        <div class="Page-funcoptimization">
          <h4>功能优化</h4>
          <div class="Page-funcopt-content">
            <h4>站点系统-实时运行</h4>
            <div class="pfcontent">站点系统中的实时运行图，将支持设备选择，根据用户所选设备展示对应的数据折线图。</div>
            <h4 class="title-top">设备监控-单体电池</h4>
            <div class="pfcontent">设备监控中的BMS设备-单体电池视图，新增“最高/最低电压”、“最高/最低温度”数据字段展示。</div>
            <h4 class="title-top">日期筛选</h4>
            <div class="pfcontent">平台图表日期筛选从“近 30 日”、“1 年内”调整为“近 31 日”、“近 12 月”。</div>
            <h4 class="title-top">多站总览-充放电统计 和 收益统计柱状图单位展示方式调整</h4>
            <div class="pfcontent">电量: 电量在1MWh以下时，使用 kWh 为单位，超过 1 MWh 时以 MWh 为单位 (近12 月除外)。 收益: 金额在万以下时，使用元为单位，超过万时以万元为单位 (近 12 月除外)。</div>
            <h4 class="title-top">电站概览-站点信息</h4>
            <div class="pfcontent">支持切换和放大电站图片。</div>
            <h4 class="title-top">电站概览-功能说明</h4>
            <div class="pfcontent">电站概览中的综合效率 和 放电达成率标题后增加功能说明 icon，鼠标移至该区域可浮现功能说明文字。</div>
          </div>
        </div>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="handleClose">{{ $t('我知道了') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  export default {
    name: 'UpdateDialog',
    data() {
      return {
        dialogVisible: false
      }
    },
    methods: {
      handleClose() {
        this.dialogVisible = false
      }
    }
  }
</script>
<style lang="scss" scoped>
  .udan-ems-dialog {
    ::v-deep .dialog-desc {
      .el-dialog__body {
        height: 500px;
        overflow-y: auto;
        padding-top: 13px;
      }
      .dialog-title {
        display: flex;
        // margin-bottom: 5px;
      }
      .title-top {
        margin-top: 12px;
      }
      .itembox1 {
        width: 100%;
        // height: 150px;
        color: #000000;
        margin-bottom: 32px;

        .update-Time {
          margin-bottom: 12px;
        }
        .Page-newfunc {
          width: 100%;
          // height: 130px;
          color: #000000;
          margin: 0 5px;
          .Page-newfunc-detail {
            width: 100%;
            // height: 100px;
            margin-top: 10px;
            background: rgba(0, 0, 0, 0.03);
            border-radius: 4px 4px 4px 4px;
            opacity: 1;
            padding: 20px 15px;
            line-height: 30px;
          }
        }
        .Page-funcoptimization {
          margin-top: 30px;
        }
      }
      .itembox2 {
        margin: 20px 0;
        color: #000000;
        .update-Time {
          margin-bottom: 12px;
        }
        .Page-adjustment {
          width: 100%;
          // height: 130px;
          color: #000000;
          margin: 0 5px;

          .Page-adjust-content {
            width: 100%;
            // height: 100px;
            background: rgba(0, 0, 0, 0.03);
            border-radius: 4px 4px 4px 4px;
            opacity: 1;
            padding: 20px 15px;
            margin-top: 10px;
            line-height: 30px;
          }
        }
        .Page-newfunction {
          width: 100%;
          // height: 190px;
          color: #000000;
          margin-top: 20px;
          margin-left: 5px;
          margin-right: 5px;

          .Page-newfunc-content {
            width: 100%;
            // height: 170px;
            background: rgba(0, 0, 0, 0.03);
            border-radius: 4px 4px 4px 4px;
            opacity: 1;
            padding: 20px 15px;
            margin-top: 10px;
            line-height: 30px;
            .pncontent {
              // margin-bottom: 10px;
            }
          }
        }
        .Page-funcoptimization {
          width: 100%;
          // height: 510px;
          color: #000000;
          margin-top: 30px;
          margin-left: 5px;
          margin-right: 5px;
          .Page-funcopt-content {
            width: 100%;
            // height: 500px;
            background: rgba(0, 0, 0, 0.03);
            border-radius: 4px 4px 4px 4px;
            opacity: 1;
            padding: 20px 15px;
            margin-top: 10px;
            line-height: 30px;
            .pfcontent {
              // margin-bottom: 10px;
            }
          }
        }
      }
      .itembox3 {
        width: 100%;
        height: 280px;
        color: #000000;
        margin-bottom: 32px;
        .update-Time {
          margin-bottom: 12px;
        }
        .Page-newfunc {
          width: 100%;
          height: 230px;
          color: #000000;
          margin: 0 5px;
          .Page-newfunc-detail {
            width: 100%;
            // height: 230px;
            margin-top: 10px;
            background: rgba(0, 0, 0, 0.03);
            border-radius: 4px 4px 4px 4px;
            opacity: 1;
            padding: 20px 15px;
            line-height: 30px;
            .pndcontent {
              // margin-bottom: 10px;
            }
          }
        }
      }
    }
  }
</style>
